import { render, staticRenderFns } from "./discrepancy-report.vue?vue&type=template&id=36fef0fe&"
import script from "./js/discrepancy-report.js?vue&type=script&lang=js&"
export * from "./js/discrepancy-report.js?vue&type=script&lang=js&"
import style0 from "./discrepancy-report.vue?vue&type=style&index=0&id=36fef0fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports